import React from "react";
import Rightaside from "../reusable/Rightaside";
import { HOME_BUSINESSES, BUSSINESS_CARDS, HOME_BUSSINESS_ASIDE, HOME_BUSSINENSS_DEMAND_SKILLS } from "../utils/constants";
import TopBarCards from "../reusable/TopBarCards";
import { IMAGES } from "../utils/images";
import "../Styles/forBusiness.css";
import CourseCard from "../reusable/Course-card";
import LeftAside from "../reusable/Leftaside";

const ForBusinesses = () => {
  return (
    <div className="outlet-render">
      <Rightaside {...HOME_BUSINESSES} />
      <div className="business-cards-container">
        {BUSSINESS_CARDS.map((item) => {
          return <TopBarCards {...item} />;
        })}
      </div>
      <div className="partners-main">
        <h1 className="partners-heading">
          Join over 100+ companies using our platform to develop talent
        </h1>
        <img src={IMAGES.PARTNERS} alt="partners" />
      </div>
      <CourseCard {...HOME_BUSSINENSS_DEMAND_SKILLS}/>
      <LeftAside {...HOME_BUSSINESS_ASIDE}/>
    </div>
  );
};

export default ForBusinesses;
